import { FC } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';

import { TCustomerType } from '../../types.ts';
import { normalizeData } from '../../utils/normalize-data.ts';

import { useColumnsVisibility } from '@/contexts/column-visibility';
import { usePagination, useSorting } from '@/hooks';
import { API } from '@/services/api';
import { PaginatedTable } from '@/widgets/paginated-table';

export const CustomersTable: FC = () => {
    const { visibleColumns } = useColumnsVisibility<TCustomerType>();
    const [searchParams] = useSearchParams();
    const { pagination } = usePagination();
    const { sort } = useSorting();
    const searchValue = searchParams.get('search');
    const { data, isLoading, isPending } = useQuery({
        ...API.USERS.getUsers({
            search: searchValue,
            ...sort,
            ...pagination,
        }),
    });

    return (
        <PaginatedTable<TCustomerType>
            loading={isPending || isLoading}
            columns={visibleColumns}
            dataSource={normalizeData(data?.result || [])}
            total={data?.total}
        />
    );
};
